import { CajaCurricularI } from "interfaces/CajaCurricular";
import { EspacioCurricularI } from "interfaces/EspacioCurricular";
import { PlanEstudioI } from "interfaces/PlanEstudio";

export interface infoFecthCajaCurricularI {
  id: number | string;
  nombre: string;
  planesEstudio: PlanEstudioI[];
  espaciosCurriculares: EspacioCurricularI[];
}

class CajaCurricular implements CajaCurricularI {
  id: number | string;
  nombre: string;
  planesEstudio: PlanEstudioI[];
  espaciosCurriculares: EspacioCurricularI[];

  constructor(infoFetch: infoFecthCajaCurricularI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.planesEstudio = infoFetch.planesEstudio;
    this.espaciosCurriculares = infoFetch.espaciosCurriculares;
  }
}

export const makeCajaCurricular = (infoFetch: infoFecthCajaCurricularI) => {
  return new CajaCurricular(infoFetch);
};
